import React from 'react';
import PropTypes from 'prop-types';

const Star = ({ filled = false }) => (
  <svg width="50" height="50" viewBox="0 0 24 24">
    <path
      fill={filled ? '#FF9500' : '#DDDDDD'}
      d="M12 .587l3.668 7.425 8.2.637-6 5.847 1.42 8.285L12 18.763l-7.288 3.918L6.132 14.396l-6-5.847 8.2-.637L12 .587z"
    />
  </svg>
);


Star.propTypes = {
  filled: PropTypes.bool,
};

export default Star;
